import React, { useState, useEffect } from 'react';
import {
  FacebookOutlined,
  InstagramOutlined,
  TwitterOutlined,
  ArrowUpOutlined,
} from '@ant-design/icons';

import {
  FooterWrapper,
  FooterContent,
  FooterColumn,
  FooterTitle,
  FooterLink,
  BottomBar,
  BottomBarInner,
  Copyright,
  SocialLinks,
  SocialLink,
  BackToTop,
} from './styles';

export default function Footer() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <FooterWrapper>
        <FooterContent>
          <FooterColumn>
            <FooterTitle>Compradores</FooterTitle>
            <FooterLink to="/buscar">Explorar libros</FooterLink>
            <FooterLink to="/buscar?categoria=ficcion">Ficción</FooterLink>
            <FooterLink to="/buscar?categoria=no-ficcion">No Ficción</FooterLink>
            <FooterLink to="/buscar?categoria=clasicos">Clásicos</FooterLink>
            <FooterLink to="/carrito">Mi carrito</FooterLink>
            <FooterLink to="/cuenta?tab=favoritos">Mis favoritos</FooterLink>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Vendedores</FooterTitle>
            <FooterLink to="/registro">Registrar tienda</FooterLink>
            <FooterLink to="/cuenta">Mi tienda</FooterLink>
            <FooterLink to="#">Guía del vendedor</FooterLink>
            <FooterLink to="#">Tarifas y comisiones</FooterLink>
            <FooterLink to="#">Consejos de envío</FooterLink>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Sobre Nosotros</FooterTitle>
            <FooterLink to="#">Quiénes somos</FooterLink>
            <FooterLink to="#">Nuestra misión</FooterLink>
            <FooterLink to="#">Trabaja con nosotros</FooterLink>
            <FooterLink to="#">Blog</FooterLink>
            <FooterLink to="#">Prensa</FooterLink>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Ayuda</FooterTitle>
            <FooterLink to="#">Centro de ayuda</FooterLink>
            <FooterLink to="#">Contacto</FooterLink>
            <FooterLink to="#">Política de devolución</FooterLink>
            <FooterLink to="#">Términos y condiciones</FooterLink>
            <FooterLink to="#">Privacidad</FooterLink>
          </FooterColumn>
        </FooterContent>

        <BottomBar>
          <BottomBarInner>
            <Copyright>
              &copy; 2026 Red de Estantes. Todos los derechos reservados.
            </Copyright>
            <SocialLinks>
              <SocialLink href="#" aria-label="Facebook">
                <FacebookOutlined />
              </SocialLink>
              <SocialLink href="#" aria-label="Instagram">
                <InstagramOutlined />
              </SocialLink>
              <SocialLink href="#" aria-label="Twitter">
                <TwitterOutlined />
              </SocialLink>
            </SocialLinks>
          </BottomBarInner>
        </BottomBar>
      </FooterWrapper>

      <BackToTop $visible={showBackToTop} onClick={scrollToTop}>
        <ArrowUpOutlined />
      </BackToTop>
    </>
  );
}
